import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./i18n";
import "./index.css";

// Validate required environment variables at startup
const requiredEnvVars = ["VITE_SUPABASE_URL", "VITE_SUPABASE_PUBLISHABLE_KEY"] as const;
for (const key of requiredEnvVars) {
  if (!import.meta.env[key]) {
    throw new Error(`Missing required environment variable: ${key}. The app cannot start without it.`);
  }
}

createRoot(document.getElementById("root")!).render(<App />);

// Remove loading skeleton after React hydrates
if (typeof window !== 'undefined') {
  const loader = document.getElementById('vx-loader');
  if (loader) loader.remove();
}
